import { ReduxModel } from 'core/models';

const reportSelector = ({ report }: ReduxModel.IGlobalState) => report;
const authSelector = ({ auth }: ReduxModel.IGlobalState) => auth;

const reportViewSelector = ({ reportView }: ReduxModel.IGlobalState) => reportView;

export { reportSelector, reportViewSelector, authSelector };
